import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaTasks } from "react-icons/fa";
import { IoMdDoneAll } from "react-icons/io";
import { MdMail } from "react-icons/md";
import { SlPeople } from "react-icons/sl";
import { Link, useLocation } from "react-router-dom";
import DeleteModal from "../../../core/common/modals/DeleteModal";
import Table from "../../../core/common/dataTable/index";
import { HiEllipsisVertical } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
// import { Tab } from "bootstrap";
import {
  deleteTemplate,
  addEditTemplate,
  fetchProfile,
} from "../../../core/data/redux/slices/ProfileSlice";

import WhatsappTemplateOffcanvas from "./WhatsappTemplateOffcanvas";
import EmailTemplateOffcanvas from "./EmailTemplateOffcanvas";
import {
  resetSelectedTemplate,
  setSelectedTemplate,
} from "../../../core/data/redux/slices/SelectedTemplateSlice";
import { useDebounce } from "../../../core/hooks/useDebounce";

const Templates = () => {
  const [columnVisibility, setColumnVisibility] = useState({
    "": true,
    Title: true,
    Message: true,
  });
  const [whatsappTemplatePage, setWhatsappTemplatePage] = useState(1);
  const [whatsappTemplateLimit, setWhatsappTemplateLimit] = useState("10");
  const [searchWhatsappTemplateQuery, setSearchWhatsappTemplateQuery] =
    useState("");
  const [emailTemplatePage, setEmailTemplatePage] = useState(1);
  const [emailTemplateLimit, setEmailTemplateLimit] = useState("10");
  const [searchEmailTemplateQuery, setSearchEmailTemplateQuery] = useState("");
  const [showFavouriteWhatsappTemplates, setShowFavouriteWhatsappTemplates] =
    useState(false);
  const [deleteModalText, setDeleteModalText] = useState("");
  const [activeTab, setActiveTab] = useState(() =>
    window.location.hash === "#emailTemplates"
      ? "emailTemplates"
      : "whatsappTemplates"
  );
  const [showFavouriteEmailTemplates, setShowFavouriteEmailTemplates] =
    useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const debouncedWhatsappSearchQuery = useDebounce(searchWhatsappTemplateQuery);
  const debouncedEmailSearchQuery = useDebounce(searchEmailTemplateQuery);
  const userProfile = useSelector((state) => state.profile);
  const handleWhatsappTemplatePageChange = (
    newWhatsappPage,
    newWhatsappPageSize
  ) => {
    setWhatsappTemplatePage(newWhatsappPage);
    setWhatsappTemplateLimit(newWhatsappPageSize);
  };
  const handleEmailTemplatePageChange = (newEmailPage, newEmailPageSize) => {
    setEmailTemplatePage(newEmailPage);
    setEmailTemplateLimit(newEmailPageSize);
  };
  const handleWhatsappTemplateEditClick = (record) => {
    const updatedRecord = {
      ...record,
      templateType: "whatsapp",
    };
    dispatch(setSelectedTemplate(updatedRecord));
  };
  // useEffect(() => {
  //   const hash = window.location.hash.replace("#", "");
  //
  //   if (hash === "whatsappTemplates" || hash === "emailTemplates") {
  //     const tabLink = document.querySelector(`[data-bs-target="#${hash}"]`);
  //     console.log(tabLink, "tabLink for hash:", hash);
  //
  //     if (tabLink) {
  //       console.log("clicking tab link for:", hash);
  //
  //       tabLink.click();
  //     }
  //   }
  // }, []);
  function activateTemplateTab(hash) {
    console.log("Activating tab via React state:", hash);
    if (hash === "whatsappTemplates" || hash === "emailTemplates") {
      setActiveTab(hash);
    }
  }
  useEffect(() => {
    const run = () => {
      const hash = window.location.hash.replace("#", "");
      console.log("Current hash:", hash);
      if (hash === "whatsappTemplates" || hash === "emailTemplates") {
        activateTemplateTab(hash);
      }
    };

    run(); // initial (on mount)
    window.addEventListener("hashchange", run);
    return () => window.removeEventListener("hashchange", run);
  }, [location]); // do NOT put window.location here

  useEffect(() => {
    const filters = {
      whatsappTemplatePage,
      whatsappTemplateLimit,
      searchWhatsappTemplates: debouncedWhatsappSearchQuery,
    };

    dispatch(fetchProfile(filters));
  }, [
    whatsappTemplatePage,
    whatsappTemplateLimit,
    debouncedWhatsappSearchQuery,
  ]);
  useEffect(() => {
    const filters = {
      emailTemplatePage,
      emailTemplateLimit,
      searchEmailTemplates: debouncedEmailSearchQuery,
    };

    dispatch(fetchProfile(filters));
  }, [emailTemplatePage, emailTemplateLimit, debouncedEmailSearchQuery]);
  const handleEmailTemplateEditClick = (record) => {
    const updatedRecord = {
      ...record,
      templateType: "email",
    };
    dispatch(setSelectedTemplate(updatedRecord));
  };

  const onSaveOffCanvas = () => {
    setWhatsappTemplateLimit("10");
    setEmailTemplateLimit("10");
  };

  const handleWhatsappStarToggle = async (record) => {
    const templateData = {
      templateType: "whatsapp",
      template_id: record.whatsappTemplate_id,
      whatsappTemplateTitle: record.whatsappTemplateTitle,
      whatsappTemplateMessage: record.whatsappTemplateMessage,
      whatsappTemplateIsFavourite: !record.whatsappTemplateIsFavourite,
    };

    try {
      await dispatch(addEditTemplate(templateData)).unwrap();

      // Refetch templates to get updated list
      const filters = {
        whatsappTemplatePage,
        whatsappTemplateLimit,
        searchWhatsappTemplates: searchWhatsappTemplateQuery,
        emailTemplatePage,
        emailTemplateLimit,
        searchEmailTemplates: searchEmailTemplateQuery,
      };
      dispatch(fetchProfile(filters));
    } catch (error) {
      console.error("Error toggling WhatsApp template favorite:", error);
    }
  };
  const handleEmailStarToggle = async (record) => {
    const templateData = {
      templateType: "email",
      template_id: record.emailTemplate_id,
      emailTemplateTitle: record.emailTemplateTitle,
      emailTemplateSubject: record.emailTemplateSubject,
      emailTemplateBody: record.emailTemplateBody,
      emailTemplateIsFavourite: !record.emailTemplateIsFavourite,
    };

    try {
      await dispatch(addEditTemplate(templateData)).unwrap();

      // Refetch templates to get updated list
      const filters = {
        whatsappTemplatePage,
        whatsappTemplateLimit,
        searchWhatsappTemplates: searchWhatsappTemplateQuery,
        emailTemplatePage,
        emailTemplateLimit,
        searchEmailTemplates: searchEmailTemplateQuery,
      };
      dispatch(fetchProfile(filters));
    } catch (error) {
      console.error("Error toggling email template favorite:", error);
    }
  };
  const selectedTemplate = useSelector((state) => state.selectedTemplate);

  const handleDeleteTemplate = () => {
    const templateDataDelete = {
      templateType: `${selectedTemplate.templateType}Template`,
      ...(selectedTemplate.templateType === "whatsapp"
        ? { template_id: selectedTemplate.whatsappTemplate_id }
        : { template_id: selectedTemplate.emailTemplate_id }),
    };
    dispatch(deleteTemplate(templateDataDelete));
    onSaveOffCanvas();
  };
  const handleBulkSelection = (selectedRowKeys, selectedRows) => {};

  const whatsappTemplateColumns = [
    {
      title: "Title",
      dataIndex: "whatsappTemplateTitle",
      key: "whatsappTemplateTitle",
      width: 200,
      render: (text, record) => {
        return (
          <div className="cell-content justify-content-between">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#whatsapp_template_offcanvas"
              style={{
                padding: 5,
                maxWidth: 400,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                padding: 5,
              }}
              onClick={() => {
                handleWhatsappTemplateEditClick(record);
              }}
            >
              {text}
            </Link>

            <div>
              <Link
                to="#"
                className="action-icon "
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onClick={() => {
                  handleWhatsappTemplateEditClick(record);
                }}
              >
                <HiEllipsisVertical />
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#whatsapp_template_offcanvas"
                >
                  <i className="ti ti-edit text-blue" /> Edit
                </Link>
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target={`#delete_${deleteModalText}`}
                  onClick={() => {
                    setDeleteModalText("template");
                  }}
                >
                  <i className="ti ti-trash text-danger"></i> Delete
                </Link>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Message",
      dataIndex: "whatsappTemplateMessage",
      key: "whatsappTemplateMessage",
      width: 235,
      render: (text, record) => {
        return (
          <div
            className=""
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </div>
        );
      },
    },
  ];
  const emailTemplateColumns = [
    // {
    //   title: "",
    //   dataIndex: "isFavourite",
    //   width: 40,
    //   render: (_, record, index) => (
    //     <div
    //       className="set-star rating-select"
    //       onClick={() => handleEmailStarToggle(record)}
    //       style={{ cursor: "pointer" }}
    //     >
    //       <i
    //         className={`fa ${
    //           record.emailTemplateIsFavourite
    //             ? "fa-solid fa-star"
    //             : "fa-regular fa-star"
    //         }`}
    //         style={{
    //           color: record.emailTemplateIsFavourite ? "gold" : "gray",
    //         }}
    //       ></i>
    //     </div>
    //   ),
    // },
    {
      title: "Title",
      dataIndex: "emailTemplateTitle",
      key: "emailTemplateTitle",
      width: 200,
      // onCell: () => ({
      //   className: "hoverable-cell", // Adding a class for the cell
      // }),

      render: (text, record) => {
        return (
          <div className="cell-content justify-content-between">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="offcanvas"
              data-bs-target="#email_template_offcanvas"
              style={{ padding: 5 }}
              onClick={() => {
                handleEmailTemplateEditClick(record);
              }}
            >
              {text}
            </Link>

            <div>
              <Link
                to="#"
                className="action-icon "
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onClick={() => {
                  handleEmailTemplateEditClick(record);
                }}
              >
                <HiEllipsisVertical />
              </Link>
              <div className="dropdown-menu dropdown-menu-right">
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#email_template_offcanvas"
                >
                  <i className="ti ti-edit text-blue" /> Edit
                </Link>
                <Link
                  className="dropdown-item"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target={`#delete_${deleteModalText}`}
                  onClick={() => {
                    setDeleteModalText("template");
                  }}
                >
                  <i className="ti ti-trash text-danger"></i> Delete
                </Link>
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Subject",
      dataIndex: "emailTemplateSubject",
      key: "emailTemplateSubject",
      width: 200,
      render: (text, record) => {
        return (
          <div
            className=""
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </div>
        );
      },
    },
    {
      title: "Body",
      dataIndex: "emailTemplateBody",
      key: "emailTemplateBody",
      width: 235,
      render: (text, record) => {
        return (
          <div
            className=""
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {text}
          </div>
        );
      },
    },
  ];

  const filteredWhatsappTemplateData =
    userProfile?.templates?.whatsappTemplates?.whatsappTemplatesData?.filter(
      (template) => {
        return template;
      }
    );

  const filteredEmailTemplateData =
    userProfile?.templates?.emailTemplates?.emailTemplatesData?.filter(
      (template) => {
        return template;
      }
    );
  console.log(
    userProfile.templates?.whatsappTemplates,
    "userProfile.templates"
  );
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="card mb-3">
              <div className="card-header">
                <ul
                  className="nav nav-tabs nav-tabs-bottom mb-2"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <Link
                      to="#whatsappTemplates"
                      // data-bs-toggle="tab"
                      // data-bs-target="#whatsappTemplates"
                      className={`nav-link ${
                        activeTab === "whatsappTemplates" ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setSearchEmailTemplateQuery("");
                        setSearchWhatsappTemplateQuery("");
                        window.location.hash = "whatsappTemplates";
                        activateTemplateTab("whatsappTemplates");
                      }}
                    >
                      <i className="fa-brands fa-whatsapp me-2"></i>
                      Whatsapp
                    </Link>
                  </li>
                  <li className="nav-item" role="presentation">
                    <Link
                      to="#emailTemplates"
                      // data-bs-toggle="tab"
                      // data-bs-target="#emailTemplates"
                      className={`nav-link ${
                        activeTab === "emailTemplates" ? "active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        setSearchEmailTemplateQuery("");
                        setSearchWhatsappTemplateQuery("");
                        window.location.hash = "emailTemplates";
                        activateTemplateTab("emailTemplates");
                      }}
                    >
                      <MdMail className="me-2" />
                      Email
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="card-body pb-0">
                <div className="tab-content pt-0">
                  <div
                    // className="tab-pane fade active show"
                    className={`tab-pane fade ${
                      activeTab === "whatsappTemplates" ? "active show" : ""
                    }`}
                    id="whatsappTemplates"
                    role="tabpanel"
                  >
                    <div className="row align-items-center mb-3">
                      <div className="col-sm-12">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="page-header mb-0">
                            <div className="row align-items-center ">
                              <h4 className="page-title mb-0 me-2">
                                Templates
                                <span className="count-title">
                                  {
                                    userProfile.templates?.whatsappTemplates
                                      ?.whatsappTemplatePagination
                                      ?.totalTemplates
                                  }
                                </span>
                              </h4>
                            </div>
                          </div>

                          <div className="d-flex">
                            <div className="icon-form me-2 mb-sm-0">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search"
                                value={searchWhatsappTemplateQuery}
                                onChange={(text) =>
                                  setSearchWhatsappTemplateQuery(
                                    text.target.value
                                  )
                                }
                              />
                            </div>

                            <Link
                              to="#"
                              className="btn btn-primary me-2"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#whatsapp_template_offcanvas"
                              onClick={() => {
                                // setSelectedContact(null);
                                dispatch(resetSelectedTemplate());
                              }}
                              disabled={userProfile.isLoading}
                            >
                              <i className="ti ti-square-rounded-plus me-2" />
                              Add
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"></div>
                      </div>
                    </div>
                    <div className="custom-table">
                      <Table
                        dataSource={filteredWhatsappTemplateData}
                        columns={whatsappTemplateColumns}
                        rowKey="whatsappTemplate_id"
                        scrollX={true}
                        loading={userProfile.isLoading}
                        pagination={{
                          current: whatsappTemplatePage,
                          pageSize: parseInt(whatsappTemplateLimit),
                          total:
                            userProfile.templates?.whatsappTemplates
                              ?.whatsappTemplatePagination?.totalTemplates || 0,
                          showSizeChanger: true,
                          showQuickJumper: true,
                          pageSizeOptions: ["10", "20", "30", "50"],
                          showTotal: (total, range) =>
                            `Showing ${range[0]}-${range[1]} of ${total} entries`,
                        }}
                        onPaginationChange={handleWhatsappTemplatePageChange}
                        onSelectionChange={handleBulkSelection}
                      />
                    </div>
                  </div>
                  <div
                    // className="tab-pane fade show"
                    className={`tab-pane fade ${
                      activeTab === "emailTemplates" ? "active show" : ""
                    }`}
                    id="emailTemplates"
                    role="tabpanel"
                  >
                    <div className="row align-items-center mb-3">
                      <div className="col-sm-12">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="page-header mb-0">
                            <div className="row align-items-center">
                              <h4 className="page-title mb-0 me-2">
                                Templates
                                <span className="count-title">
                                  {
                                    userProfile.templates?.emailTemplates
                                      ?.emailTemplatePagination?.totalTemplates
                                  }
                                </span>
                              </h4>
                            </div>
                          </div>
                          <div className="d-flex">
                            <div className="icon-form me-2 mb-sm-0">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search"
                                value={searchEmailTemplateQuery}
                                onChange={(text) =>
                                  setSearchEmailTemplateQuery(text.target.value)
                                }
                              />
                            </div>

                            <Link
                              to="#"
                              className="btn btn-primary me-2"
                              data-bs-toggle="offcanvas"
                              data-bs-target="#email_template_offcanvas"
                              onClick={() => {
                                // setSelectedContact(null);
                                dispatch(resetSelectedTemplate());
                              }}
                              disabled={userProfile.isLoading}
                            >
                              <i className="ti ti-square-rounded-plus me-2" />
                              Add
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-8">
                        <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"></div>
                      </div>
                    </div>
                    <div className="custom-table">
                      <Table
                        dataSource={filteredEmailTemplateData}
                        columns={emailTemplateColumns}
                        rowKey="emailTemplate_id"
                        scrollX={true}
                        loading={userProfile.isLoading}
                        pagination={{
                          current: emailTemplatePage,
                          pageSize: parseInt(emailTemplateLimit),
                          total:
                            userProfile.templates?.emailTemplates
                              ?.emailTemplatePagination?.totalTemplates || 0,
                          showSizeChanger: true,
                          showQuickJumper: true,
                          pageSizeOptions: ["10", "20", "30", "50"],
                          showTotal: (total, range) =>
                            `Showing ${range[0]}-${range[1]} of ${total} entries`,
                        }}
                        onPaginationChange={handleEmailTemplatePageChange}
                        onSelectionChange={handleBulkSelection}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <WhatsappTemplateOffcanvas onSaveOffCanvas={onSaveOffCanvas} />
          <EmailTemplateOffcanvas onSaveOffCanvas={onSaveOffCanvas} />
          {
            <DeleteModal
              text={deleteModalText}
              onDelete={handleDeleteTemplate}
            />
          }
        </div>
      </div>
    </div>
  );
};

export default Templates;
